<template src="./ask.html"></template>

<script lang="ts">
import iaConfig from 'widgets/instant-answers/instant-answers.config'
import AskTips from './AskTips.vue'
import HintText from 'objects/hint/HintText.vue'
import SearchField from 'objects/form/SearchField.vue'
import globalStore from 'init/global-store'
import trackingService from 'services/tracking-service'


export default {
  data() {
    return {
      iaConfig,
      showLearnMore: false
    }
  },
  components: {
    'tt-ask-tips': AskTips,
    'tt-hint-text': HintText,
    'tt-search-field': SearchField
  },
  props: {
    alertText: { type: String },
    countText: { type: String },
    errorText: { type: String },
    inAskMode: {
      type: Boolean,
      default: false
    },
    modelValue: String // questionText
  },
  emits: ['update:modelValue'],
  computed: {
    askLabel() {
      return this.$msg(this.inAskMode ? 'ia.askLabel' : 'ia.promptLabel')
    },
    askLabelMobile() {
      return this.$msg(this.inAskMode ? 'ia.askLabel.mobile' : 'ia.promptLabel.mobile')
    },
    hintSeparator() {
      return ' <span class="tt-o-hint__dot">' + this.$msg('hint.error.separator') + '</span> '
    },
    hintText() {
      if (this.errorText) {
        return this.errorText
      }
      if (this.alertText) {
        return this.alertText
      }
      const countText = this.countText ? this.countText + this.hintSeparator : ''
      if (this.inAskMode) {
        return countText + this.$msg('ia.askHint')
      }
      return (!this.modelValue ? '' : countText) + this.$msg('ia.promptHint')
    },
    hintType() {
      return this.errorText ? 'error' : (this.alertText ? 'alert' : 'info')
    },
    learnMoreText() {
      return this.showLearnMore ? this.$msg('ia.hideTipsLink') : this.$msg('ia.learnMoreLink')
    },
    showLearnMoreLink() {
      return iaConfig.learnMoreEnabled && !this.alertText && !this.inAskMode && !this.modelValue
    }
  },
  methods: {
    toggleLearnMore() {
      this.showLearnMore = !this.showLearnMore
      if (this.showLearnMore) {
        trackingService.queueEvent('instant-answers', 'learn', globalStore.sku)
      }
    },
    updateText(text) {
      this.$emit('update:modelValue', text)
    }
  },
  watch: {
    modelValue() {
      if (this.modelValue && this.showLearnMore) {
        this.showLearnMore = false
      }
    }
  }
}
</script>

<style lang="scss" src="./ask.scss"></style>
